import Formatter from "./formatter.service";

const formatterModule = angular
  .module("app.services.formatter", [])
  .service("Formatter", Formatter);

export default formatterModule;



// WEBPACK FOOTER //
// ./src/services/formatter/formatter.module.js